import { useLocation } from '@tanstack/react-router'

import { useAppRouter } from '@/shared/lib/router'
import { LandingHeader } from '@/shared/ui/LandingHeader'
import { LandingFooter } from '@/shared/ui/LandingFooter'

import { LandingAuthModal } from '../LandingAuthModal'
import { LandingHero } from '../landing/LandingHero'
import { LandingJourneySection } from '../landing/LandingJourneySection'
import { LandingHowItWorks } from '../landing/LandingHowItWorks'
import { LandingStatsSection } from '../landing/LandingStatsSection'
import { LandingFinalCTA } from '../landing/LandingFinalCTA'

export function LandingPage() {
  const location = useLocation()
  const router = useAppRouter()

  const modal = (location.search as Record<string, unknown>)?.modal as
    | 'sign-in'
    | 'sign-up'
    | undefined

  const openModal = (action: 'sign-in' | 'sign-up') =>
    router.push(`/?modal=${action}`)

  const closeModal = () => router.push('/')

  return (
    <div className="min-h-screen">
      <LandingHeader
        onSignIn={() => openModal('sign-in')}
        onSignUp={() => openModal('sign-up')}
      />

      <main>
        <LandingHero
          onSignIn={() => openModal('sign-in')}
          onSignUp={() => openModal('sign-up')}
        />
        <LandingJourneySection />
        <LandingHowItWorks />
        <LandingStatsSection />
        <LandingFinalCTA
          onSignIn={() => openModal('sign-in')}
          onSignUp={() => openModal('sign-up')}
        />
      </main>

      <LandingFooter />

      <LandingAuthModal modal={modal} onClose={closeModal} />
    </div>
  )
}
